import type { Printer } from '@features/printer/types';
import type { BarcodePrintProgress } from '@shared/components/barcode-print';

import { toast } from 'sonner';
import { useState } from 'react';

import { PrinterEnum } from '@features/printer/types';
import { PrintHandler } from '@features/printer/utils/print-handler';
import { usePrinter } from '@features/printer/providers/printer-provider';

const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const useBarcodePrinter = () => {
  const { printerList } = usePrinter();
  const [progress, setProgress] = useState<BarcodePrintProgress | null>(null);

  const printer: Printer | undefined = printerList.find((p: Printer) => p.type === PrinterEnum.Barcode);

  const print = (zpl: string[], copies: number, reference?: string) => {
    PrintHandler.zpl(printer!.originalName, zpl, copies, { label: 'Étiquette code-barre', reference });
  };

  /** Prints each label sequentially, leaving the printer time to process every job. */
  const printBatch = async (labels: string[], toZpl: (label: string) => string[], copies: number) => {
    setProgress({ done: 0, total: labels.length });
    try {
      for (const [index, label] of labels.entries()) {
        print(toZpl(label), copies, label);
        setProgress({ done: index + 1, total: labels.length });
        await wait(500);
      }
      toast.success(
        `${labels.length} étiquette${labels.length > 1 ? 's' : ''} envoyée${labels.length > 1 ? 's' : ''} à l'impression`
      );
    } finally {
      setProgress(null);
    }
  };

  return { printer, print, printBatch, progress };
};
